<div class="flex flex-col gap-4">
  <p class="text-sm font-semibold font-['Roboto_Condensed'] text-slate-600">TAs Awaiting Approval (Overdue)</p>
  @if (availableTaList().length > 0) {
    <div class="flex gap-2 items-center">
      <input type="text"
             pInputText
             [(ngModel)]="searchStr"
             class="w-1/2"
             pSize="small"
             placeholder="Type to filter by TA number, project code, status or staff..."
      />
      <div class="bg-white rounded-lg">
        <p-button outlined severity="secondary"
                  size="small"
                  (onClick)="clearSearchStr()">Clear</p-button>
      </div>
    </div>

    <p-table [value]="filteredTaList()"
             stripedRows
             [tableStyle]="{'min-width': '40rem'}"
             sortField="taNumber"
             [sortOrder]="-1"
             class="ta-list border-[1px] border-surface-300 rounded-lg">
      <ng-template #header>
        <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
          <th class="rounded-tl-lg ta-col-prepaid"></th>
          <th class="ta-col-attachment"></th>
          <th>TA Number</th>
          <th pSortableColumn="startDate" style="align-items: center">
            <div class="flex items-center gap-2">
              Travel Date
              <p-sortIcon field="startDate" />
            </div>
          </th>
          <th>Primary Traveller</th>
          <th>Approval Workflow</th>
          <th>Overdue Approver</th>
          <th class="ta-col-actions">Action</th>
          <th class="rounded-tr-lg ta-col-comments"></th>
        </tr>
      </ng-template>
      <ng-template #body let-taSubmission let-rowIndex="rowIndex">
        <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer" (click)="setSelectedTa(taSubmission)" (dblclick)="viewTaSubmission(taSubmission)">
          <td class="ta-col-prepaid" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg': (rowIndex === availableTaList().length - 1)}">
            <prepaid-indicator [taDetails]="taSubmission"></prepaid-indicator>
          </td>
          <td class="ta-col-attachment" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <attachment-indicator [taDetails]="taSubmission"></attachment-indicator>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <button class="text-primary-500 hover:underline font-semibold cursor-pointer"
                    (click)="viewTaSubmission(taSubmission); $event.stopPropagation()">
              {{taSubmission.taNumber}}
            </button>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.startDate | date:'dd/MM/yy'}}</td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <div class="flex gap-1 items-center">
              @if (taSubmission.travellerCount > 1) {
                <i class="fa-solid fa-users"></i>
              } @else {
                <i class="fa-solid fa-user"></i>
              }
              <span class="text-nowrap">{{taSubmission.primaryTraveller?.details?.name}}</span>
            </div>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <div class="flex gap-1 items-center">
              @for (stage of approvalWorkflow(taSubmission); track stage.context) {
                <p-badge [severity]="stage.severity" [value]="stage.label" class="text-nowrap" />
                @if (!$last) {
                  <i class="fa-light fa-chevron-right"></i>
                }
              } @empty {
                <span>-</span>
              }
            </div>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <span class="text-nowrap">{{overdueApproverName(taSubmission)}}</span>
          </td>
          <td class="ta-col-actions" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <div class="flex justify-start">
              <p-button [style]="{height:'1.5em'}" [text]="true" severity="primary" size="small" (onClick)="openManageApproversModal(taSubmission)"><span class="text-nowrap">Edit Approvers</span></p-button>
            </div>
          </td>
          <td class="ta-col-comments" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-br-lg': (rowIndex === availableTaList().length - 1)}">
            <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
          </td>
        </tr>
      </ng-template>
      <ng-template #footer>
        @if (filteredTaList().length === 0) {
          <tr class="text-xs font-normal font-['Roboto_Condensed']">
            <td class="rounded-bl-lg rounded-br-lg" colspan="9"><i>Your search returned no results.</i></td>
          </tr>
        }
      </ng-template>
    </p-table>
  } @else {
    <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">There are no overdue approvals.</div>
  }
</div>
